module.exports = __webpack_public_path__ + "img/1446005-10-2.c3008ca4.png";